import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {I18nDictionaryComponent} from '../../../shared/components/i18n-dictionary/i18n-dictionary.component';
import {AuthError} from '../../models/auth-error';
import {RequestReset} from '../../models/user';
import {Location} from '@angular/common';
import {LanguageService} from '../../../core/services/language.service';

@Component({
    selector: 'app-request-password-reset-form',
    templateUrl: './request-password-reset-form.component.html',
    styleUrls: ['./request-password-reset-form.component.scss']
})
export class RequestPasswordResetFormComponent {
    readonly emailPlaceholderTextId = 'email-placeholder';

    constructor(private _location: Location, private languageService: LanguageService) {
    }

    @Input()
    resetError: AuthError;

    @Input()
    resetSuccessful: boolean;

    @Input()
    set pending(isPending: boolean) {
        this.isPending = isPending;
        if (isPending) {
            this.form.disable();
        } else {
            this.form.enable();
        }
    }

    isPending = false;

    @Output()
    reset = new EventEmitter<RequestReset>();

    @ViewChild(I18nDictionaryComponent, {static: true})
    i18nDictionary: I18nDictionaryComponent;

    get currentLang(): string {
        return this.languageService.getCurrentLanguage().href;
    }

    // validation
    form: FormGroup = new FormGroup({
        email: new FormControl('',
            [
                Validators.email,
                Validators.required
            ]
        ),
        captcha: new FormControl('', [
            Validators.required
        ])
    });

    get emailControl() {
        return this.form.get('email');
    }

    get captchaControl() {
        return this.form.get('captcha');
    }

    submit() {
        this.form.markAllAsTouched();

        if (this.form.valid) {
            this.reset.emit(this.form.value);
        }
    }

    // Return to last page visited
    goBack() {
        this._location.back();
    }
}
